import React from 'react'
import {makeStyles } from '@material-ui/core/styles';
import TableHead from '@material-ui/core/TableHead';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';

const useStyles = makeStyles({
    StyledHead: {
      backgroundColor:"#44979e"
    },
    OrderAvaliableColumn:{
        borderStyle:"soild",
        borderWidth:1,
        borderColor:"black",
        color:"white",
        fontFamily:"Microsoft JhengHei",
        fontSize:12,
        cursor:"pointer",
        '&:hover':{
            backgroundColor:"#a1d8ff",
        },
        backgroundColor:"#5f9ea0"
    },

    OrderNotAvaliableColumn:{
        borderStyle:"soild",
        borderWidth:1,
        borderColor:"black",
        color:"white",
        fontFamily:"Microsoft JhengHei",
        fontSize:12,
        backgroundColor:"#5f9ea0"
    },
    OrderColumnCell:{
        borderStyle:"soild",
        borderWidth:1,
        borderColor:"black",
        color:"black",
        fontFamily:"Microsoft JhengHei",
        fontSize:12,
        backgroundColor:"#ffe736",
        cursor:"pointer",
    },
    OrderIcon:{
        color:"#008cff"
    }
  });
  

export default function StyledTableHead(props) {
    const classes = useStyles();
   
    return (
        <TableHead className={classes.StyledHead}>
           <TableRow>
                <TableCell className={classes.OrderNotAvaliableColumn}>序號</TableCell>
                <TableCell className={props.orderColumn === "Event_SysID"?classes.OrderColumnCell:classes.OrderAvaliableColumn} align="left" onClick={()=>props.getNewOrderStatus("Event_SysID")}>專題系統編號{props.orderColumn === "Event_SysID" ? props.orderType === "ASC" ? <div className={classes.OrderIcon}>&#9650;</div> : <div className={classes.OrderIcon}>&#9660;</div> :""}</TableCell>
                <TableCell className={props.orderColumn === "Event_Title"?classes.OrderColumnCell:classes.OrderAvaliableColumn} align="left" onClick={()=>props.getNewOrderStatus("Event_Title")}>專題標題{props.orderColumn === "Event_Title" ? props.orderType === "ASC" ? <div className={classes.OrderIcon}>&#9650;</div> : <div className={classes.OrderIcon}>&#9660;</div> :""}</TableCell>
                <TableCell className={props.orderColumn === "Event_CreatedDate"?classes.OrderColumnCell:classes.OrderAvaliableColumn} align="left" onClick={()=>props.getNewOrderStatus("Event_CreatedDate")}>專題建立日期{props.orderColumn === "Event_CreatedDate" ? props.orderType === "ASC" ? <div className={classes.OrderIcon}>&#9650;</div> : <div className={classes.OrderIcon}>&#9660;</div> :""}</TableCell>
                <TableCell className={props.orderColumn === "User_Name"?classes.OrderColumnCell:classes.OrderAvaliableColumn} align="left" onClick={()=>props.getNewOrderStatus("User_Name")}>建立者{props.orderColumn === "User_Name" ? props.orderType === "ASC" ? <div className={classes.OrderIcon}>&#9650;</div> : <div className={classes.OrderIcon}>&#9660;</div> :""}</TableCell>
                <TableCell className={props.orderColumn === "Event_SubTitle"?classes.OrderColumnCell:classes.OrderAvaliableColumn} align="left" onClick={()=>props.getNewOrderStatus("Event_SubTitle")}>專題副標題{props.orderColumn === "Event_SubTitle" ? props.orderType === "ASC" ? <div className={classes.OrderIcon}>&#9650;</div> : <div className={classes.OrderIcon}>&#9660;</div> :""}</TableCell>
                <TableCell className={classes.OrderNotAvaliableColumn} align="left">專題大綱</TableCell>
                <TableCell className={props.orderColumn === "Event_StartDate"?classes.OrderColumnCell:classes.OrderAvaliableColumn} align="left" onClick={()=>props.getNewOrderStatus("Event_StartDate")}>專題上線日期{props.orderColumn === "Event_StartDate" ? props.orderType === "ASC" ? <div className={classes.OrderIcon}>&#9650;</div> : <div className={classes.OrderIcon}>&#9660;</div> :""}</TableCell>
                <TableCell className={props.orderColumn === "Event_EndDate"?classes.OrderColumnCell:classes.OrderAvaliableColumn} align="left" onClick={()=>props.getNewOrderStatus("Event_EndDate")}>專題下線日期{props.orderColumn === "Event_EndDate" ? props.orderType === "ASC" ? <div className={classes.OrderIcon} >&#9650;</div> : <div className={classes.OrderIcon} >&#9660;</div> :""}</TableCell>
            </TableRow>
        </TableHead>
    )
}